import React, {useState} from 'react'
import { useLocation } from 'react-router-dom'
import { Grid, Box, Divider } from '@mui/material'
import SEO from './seo/seo';

import AnimalContent from './content/main';
import AnimalFilter from './filter/main';
import StateHeader from './statepage/heading';


export default function StatePage(props) {

    const location = useLocation();
    const state = decodeURI(location.pathname.split('/')[2])


    const [dogs, setDogs] = useState()

    return (
        <>
            <SEO
                title={'Hunde in ' + state + ' - ' + (dogs ? dogs[2] + " Treffer - PocketPet" : "PocketPet")}
                description={'Finde alle Hunde, die sich in Tierheimen in ' + state + ' befinden, auf einer Seite. Filter nach Rasse, Alter, Geschlecht und mehr.'}
                type='website' />

            <Box justifyContent='center' display='flex' >
                <Grid container spacing={2} marginBottom={50} sx={{ p: { xs: 3, xl: 0 } }}>

                    <Grid item xs={12}>
                        <StateHeader dogs={dogs}/>
                        <Divider />
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} xl={3}>
                        <AnimalFilter />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} xl={6}>
                        <AnimalContent setDogs={setDogs} />
                    </Grid>

                    <Grid item xs={3}>

                    </Grid>


                </Grid>


            </Box>
        </>

    )
}
